import React from 'react'


export default function useSpinning(initialValue = 0, {longSpinningTimeInMs, key, idKey} = {}) {
    longSpinningTimeInMs = longSpinningTimeInMs || 1000
    const [spinningCounter, setCounter] = React.useState(initialValue)
    const spinningCounterRef = React.useRef(spinningCounter)
    const [spinningForLongTime, setSpinningForLongTime] = React.useState(false)
    const timeoutRef = React.useRef()


    React.useEffect(() => {
        spinningCounterRef.current = spinningCounter
        if (spinningCounter <= 0) {
            setSpinningForLongTime(false)
            return
        }
        if (spinningForLongTime) {return}
        clearCurrentTimeout()
        timeoutRef.current = setTimeout(
            () => {
                if (spinningCounterRef.current > 0) {
                    setSpinningForLongTime(true)
                }
            },
            longSpinningTimeInMs
        )
    }, [spinningCounter])

    React.useEffect(() => {
        return clearCurrentTimeout
    }, [])

    function clearCurrentTimeout() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }
    }

    function increaseSpinningCounter(diff = 1) {
        setCounter(counter => counter + diff)
    }

    const decreaseSpinningCounter = React.useCallback((diff = 1) => {
        setCounter(counter => {
            if (counter <= 0) {
                console.warn(`counter <= 0 before decrease - ${counter}`)
            }
            return counter - diff
        })
    }, [])

    if (spinningCounter <= 0 && spinningForLongTime) {
        setSpinningForLongTime(false)
    }

    const spinning = spinningCounter > 0

    return {
        increaseSpinningCounter,
        decreaseSpinningCounter,
        spinning,
        spinningForLongTime,
        spinningCounter,
    }
}


const Context = React.createContext({})

export function SpinningContext({initialValue, children, logKey, ...other}) {
    const value = useSpinning(initialValue, other)


    return <Context.Provider value={value}>
        {children}
    </Context.Provider>
}

export function useSpinningContext() {
    return React.useContext(Context)
}
